<template>
  <header class="global-header" id="global-header">
    <div class="container">
      <a :href="homePage" class="global-header-left">
        <i class="global-logo"></i>
        <h1 class="global-title">政务开放平台</h1>
        <div v-if="subTitle" class="global-title-sub">
          <span class="global-title-sub_text">{{ subTitle }}</span>
        </div>
      </a>
      <div class="global-header-main" v-if="menu">
        <global-entry></global-entry>
      </div>
      <div class="global-header-right">
        <global-user></global-user>
      </div>
    </div>
  </header>
</template>

<script>
  // import { mapState } from 'vuex';
  import GlobalEntry from '../global-entry/index.vue';
  import GlobalUser from '../global-user/index.vue';
  // import config from '../../core/config';

  const homePage = '/';

  export default {
    name: 'global-header',
    data () {
      return {
        homePage,
      };
    },
    props: {
      subTitle: {
        type: String,
        default: '',
      },
      menu: {
        type: Boolean,
        default: true,
      },
    },

    methods: {},
    components: {
      GlobalEntry,
      GlobalUser,
    },
  };
</script>

<style lang="less" src="./index.less"></style>
